// src/share/platformSignupUrls.js
//
// Direct signup URLs for each social platform.
// Used by the Sharing Center library to give users a one-click path to
// create an account on a platform they don't yet have, opened in a new tab.

export const PLATFORM_SIGNUP_URLS = {
  facebook:  'https://www.facebook.com/r.php',
  instagram: 'https://www.instagram.com/accounts/emailsignup/',
  twitter:   'https://x.com/i/flow/signup',
  linkedin:  'https://www.linkedin.com/signup',
  youtube:   'https://accounts.google.com/signup',
  tiktok:    'https://www.tiktok.com/signup',
};

export const PLATFORM_LABELS = {
  facebook:  'Facebook',
  instagram: 'Instagram',
  twitter:   'X',
  linkedin:  'LinkedIn',
  youtube:   'YouTube',
  tiktok:    'TikTok',
};
